import React, { useState } from "react";
import { Box, Typography, Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./Gallery.css"; // import css

import img1 from "../images/801A8733.jpg";
import img2 from "../images/801A0469.jpg";
import img3 from "../images/801A0068.jpg";
import img4 from "../images/801A9717.jpg";
import img5 from "../images/801A9645.jpg";
import img6 from "../images/801A0279.jpg";
import img7 from "../images/801A0256.jpg";
import img8 from "../images/801A0077.jpg";
import img9 from "../images/GF surgery 21 .jpg";
import img10 from "../images/GF CLinic 2018 _2.jpg";
import img11 from "../images/GF.jpg";
import img12 from "../images/GF 2022 .jpg";
import img13 from "../images/GF team 3.jpg";
import img14 from "../images/11aba71e-e2b8-432a-93d0-5b8f0cd3204f.jpeg";
import img15 from "../images/Gundeti_Foundation_Hospital_work.jpeg";

const images = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
];

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [selectedImg, setSelectedImg] = useState(null);

  const handleOpen = (img) => {
    setSelectedImg(img);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedImg(null);
  };

  return (
    <Box className="gallery-container">
      <Typography variant="h4" className="gallery-title">
        Gallery
      </Typography>

      <div className="gallery-grid">
        {images.map((img, idx) => (
          <div key={idx} className="gallery-item" onClick={() => handleOpen(img)}>
            <img src={img} alt={`Gallery ${idx + 1}`} />
          </div>
        ))}
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth="md">
        <DialogContent sx={{ p: 0, position: "relative", background: "#000" }}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#fff",
              zIndex: 2,
            }}
          >
            <CloseIcon />
          </IconButton>
          {selectedImg && (
            <img
              src={selectedImg}
              alt="Gallery Large"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "80vh",
                display: "block",
                margin: "0 auto",
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Gallery;
